export default __webpack_public_path__ + "static/media/generic-position.4fce0da1.png";